import React from 'react';
import ExitReadinessScorecard from './ExitReadinessScorecard';

function App() {
  return (
    <div className="App">
      <ExitReadinessScorecard />
    </div>
  );
}

export default App;
